import { Box, Container, Heading, Text } from "@chakra-ui/react";

export function VoucherInformacoesGerais() {
  return (
    <Box minH="100vh" bg="#f5f7fb" color="#1f2937" px={{ base: 4, md: 6 }} py={{ base: 6, md: 10 }}>
      <Container maxW="860px" bg="white" border="1px solid #e5e7eb" borderRadius="8px" p={{ base: 5, md: 8 }}>
        <Heading as="h1" fontSize={{ base: "22px", md: "28px" }} mb={5}>
          Informações Gerais
        </Heading>

        <Heading as="h2" fontSize="18px" mb={3}>
          Impressão do Bilhete Rodoviário
        </Heading>
        <Text mb={4}>
          Para sua maior tranquilidade e conforto, recomendamos apresentar-se no guichê ou sala VIP da empresa de ônibus
          para emissão do seu bilhete com pelo menos 1 (uma) hora de antecedência ao horário de embarque, apresentando o
          documento de identidade original com fotografia. O bilhete de passagem é nominal e intransferível. O bilhete não é
          endossável.
        </Text>

        <Heading as="h2" fontSize="18px" mb={3}>
          Transferência ou Cancelamento da Passagem Rodoviária:
        </Heading>
        <Text mb={4}>
          Fica assegurado ao usuário solicitar a transferência da data ou horário de embarque, ou ainda, o cancelamento da
          passagem, desde que a solicitação seja feita diretamente no guichê da empresa de ônibus, no local de origem da
          viagem com antecedência mínima de três (03) horas do horário estabelecido para o embarque. Nos casos de
          pagamento parcelado com cartão, a devolução dos valores será efetuada de acordo com o repasse da operadora do
          cartão. O reembolso do valor cobrado será feito pelo - GoPass após a notificação da empresa de ônibus. O
          cancelamento também poderá ser solicitado por e-mail desde que solicitado em horário comercial (das 8:00 as 18:00)
          com pelo menos quatro (04) horas de antecedência do horário de embarque, desde que a passagem não tenha sido
          retirada no guichê da empresa de ônibus.
        </Text>

        <Text mb={4}>
          §1º: Nos termos do art.8º, §2º da Resolução n.º 978 da ANTT, fica a transportadora autorizada a reter até 5% (cinco
          por cento) do valor pago pela passagem rodoviária, a título de taxa de cancelamento compensatória, no caso de o
          passageiro realizar o cancelamento ou a transferência, dentro do prazo previsto no caput desta cláusula.
        </Text>

        <Text mb={4}>
          §2º: A transferência de horário ficará condicionada à disponibilidade de passagens na data e horário desejados pelo
          usuário, ficando ainda assegurado ao usuário a opção pela passagem com data e horário em aberto, assim
          permanecendo pelo prazo máximo de 12 (doze) meses, contados da data do bilhete original, ficando sujeito a reajuste
          de preço se não utilizada dentro desse prazo.
        </Text>

        <Text mb={5}>
          * Taxa de Conveniência : O Cliente reconhece e autoriza a cobrança da taxa de conveniência no ato da compra do
          bilhete rodoviário através deste canal de venda. Trata-se da fonte de renda na qual a - GoPass garante distribuição de
          passagens rodoviárias, bem como as transações de cartão de crédito e TEF, em nenhuma hipótese o valor cobrado de
          taxa de conveniência será reembolsado.
        </Text>

        <Heading as="h2" fontSize="18px" mb={3}>
          Transporte de Bagagens
        </Heading>
        <Text mb={4}>
          A vista do disposto no artigo 70 e seguintes do Decreto 2521/98, o preço da passagem abrange, a título de franquia, o
          transporte obrigatório e gratuito de bagagem no bagageiro e no volume de porta-embrulhos observados os seguintes
          limites máximos de peso e dimensão:
        </Text>

        <Text mb={3}>
          a) bagageiro, trinta quilos de peso total e volume máximo de trezentos centímetros cúbicos, limitada a maior
          dimensão de qualquer volume a um metro e no porta-embrulhos, cinco quilos de peso total, com dimensões que se
          adaptem ao local, desde que o conforto, a segurança e a higiene dos passageiros não sejam prejudicados;
        </Text>
        <Text mb={3}>
          b) excedida a franquia prevista, o passageiro pagará até meio por cento do preço da passagem correspondente ao
          serviço convencional, pelo transporte de cada quilograma de excesso; e
        </Text>
        <Text mb={5}>
          c) é vedado o transporte de produtos considerados perigosos, indicados na legislação específica, bem como aqueles
          que, por sua forma ou natureza, comprometam a segurança do veículo, de seus ocupantes ou de terceiros, nos termos
          do art.72 do Decreto 2521/98.
        </Text>

        <Text fontWeight="700">GoPass deseja-lhe uma Boa Viagem!</Text>
      </Container>
    </Box>
  );
}
